{
  "fr": {
    "ticket_category": {
      "Decisions": "Décision",
      "Issue": "Après-vente",
      "Other": "Réguliers",
      "actions": {
        "delete": "Supprimer le type de conversation"
      },
      "inputs": {
        "empty": "Pas de type"
      },
      "labels": {
        "delete": "Retirer {category}",
        "delete_description": "Êtes-vous sûr de vouloir supprimer {category} de vos types de conversation ?",
        "ticket_categories": "Types",
        "ticket_category": "Type"
      }
    }
  }
}
